export default __webpack_public_path__ + "static/white-desserto-sand-c850f7cf0e8e007433bcf5e1c45fa91d.jpg";